import React from 'react';
import { QRCodeSVG } from 'qrcode.react';

interface Props {
  userId: string;
  nickname: string;
  onClose: () => void;
}

export function QRProfileCard({ userId, nickname, onClose }: Props) {
  const url = `${window.location.origin}?user=${userId}`;

  const handleShare = async () => {
    try {
      if (navigator.share) {
        await navigator.share({ title: `${nickname} on Joystance`, url });
      } else {
        await navigator.clipboard.writeText(url);
      }
    } catch {}
  };

  return (
    <div className="flex flex-col items-center gap-5 py-2">
      <div className="text-center">
        <h3 className="text-stabeon-text font-bold text-xl">Your QR Card</h3>
        <p className="text-stabeon-muted text-xs mt-1">Let others scan to view your profile</p>
      </div>

      <div className="bg-white p-5 rounded-3xl shadow-xl">
        <QRCodeSVG value={url} size={180} level="M" />
      </div>

      <div className="text-center">
        <p className="text-stabeon-text font-bold text-lg">{nickname}</p>
        <p className="text-stabeon-muted text-[11px] mt-1 font-mono break-all px-6 leading-relaxed">
          joystance.com/u/{userId.slice(0, 12)}…
        </p>
      </div>

      <div className="flex gap-3 w-full">
        <button onClick={onClose} className="btn-ghost flex-1">Close</button>
        <button onClick={handleShare} className="btn-primary flex-1">
          🔗 Share profile
        </button>
      </div>
    </div>
  );
}
